/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Card, Tabs } from 'antd';
import { UserOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { style } from '../../Styles';
import Rider from './Rider';
import PendingRidersComponent from './PendingRiders';
import { permissionSuperAdmin } from '../../Utils/Constants/utils';
import { CheckRiderEnabled } from '../../Utils/CheckFeatures';

const RiderMultiTab = () => {
	const [activeTab, setActiveTab] = useState('1');
	const { auth } = useSelector((state) => state.auth);

	const onChange = (key) => {
		setActiveTab(key);
	};

	// Check if user is super admin
	const isSuperAdmin = auth?.profile?.role?.includes(permissionSuperAdmin);

	const riderTabItems = [
		{
			label: (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
					}}>
					<UserOutlined />
					<span style={style.navItem}>All Riders</span>
				</div>
			),
			key: '1',
			children: <Rider isActive={activeTab === '1'} />,
			show: true,
		},
		...(CheckRiderEnabled() ? [{
			label: (
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
					}}>
					<ClockCircleOutlined />
					<span style={style.navItem}>Pending</span>
				</div>
			),
			key: '2',
			children: <PendingRidersComponent isActive={activeTab === '2'} />,
			show: isSuperAdmin, // Only show for super admins
		}] : []),
	];

	// Filter tabs based on show property
	const visibleTabs = riderTabItems.filter((tab) => tab.show);

	useEffect(() => {
		// If current tab is not visible, switch to first visible tab
		if (!visibleTabs.find((tab) => tab.key === activeTab)) {
			setActiveTab(visibleTabs[0]?.key || '1');
		}
	}, [isSuperAdmin]);

	return (
		<Card hoverable bordered={false} style={style.cardStyle}>
			<Tabs activeKey={activeTab} onChange={onChange} type='card' items={visibleTabs} />
		</Card>
	);
};

export default RiderMultiTab;